<template>
  <a-modal
    :title="obj ? '编辑支付宝门店' : '新增支付宝门店'"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('close')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="shopForm"
      :model="shopForm"
      :rules="shopFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >

      <a-row type="flex">
        <a-col :span="12">
          <a-form-model-item label="门店名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px" prop="shopName">
            <a-input v-model="shopForm.shopName"  placeholder="请填写门店名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="门店编号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-input v-model="shopForm.storeId"  placeholder="请填写门店编号" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="门店类型" prop="shopType" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-radio-group v-model="shopForm.shopType">
              <a-radio key="01" value="01">直营</a-radio>
              <a-radio key="02" value="02">加盟</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="门店类目" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-input v-model="shopForm.shopCategory"  placeholder="请填写门店类目" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row type="flex">
        <a-col :span="12">
          <a-form-model-item label="法人姓名" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-input v-model="shopForm.legalName"  placeholder="请填写法人姓名" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="身份证号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-input v-model="shopForm.legalCertNo"  placeholder="请填写法人身份证号" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row type="flex">
        <a-col :span="12">
          <a-form-model-item label="手机号码" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-input v-model="shopForm.contactMobile"  placeholder="请填写手机号码" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="固定电话" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-input v-model="shopForm.contactPhone"  placeholder="请填写固定电话" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row type="flex">

        <a-col :span="12">
          <a-form-model-item label="行政区划" prop="adcId" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-cascader
              v-model="shopForm.adcId"
              :options="adcOptions"
              :load-data="loadAdcData"
              placeholder="请选择"
              change-on-select
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="商户ID" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  style="margin-bottom: 12px">
            <a-input v-model="shopForm.ipRoleId"  placeholder="请填写商户ID" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row type="flex">
        <a-col :span="24">
          <a-form-model-item label="门店地址" prop="address" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-textarea  v-model="shopForm.address" ></a-textarea>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import store from '@/store'
import { QueryIndustrySimplifyList } from '@/apis/industry'
import { QueryAdcInfo, QueryAdcList } from '@/apis/administrative'

const enumsData = store.state.enumsStore.enumsData

const shopForm = {
  shopName: undefined,
  storeId: undefined,
  adcId: undefined,
  shopType: undefined,
  address: undefined,
  contactMobile: undefined,
  contactPhone: undefined,
  ipRoleId: undefined,
  legalName: undefined,
  legalCertNo: undefined,
  shopCategory: undefined,
}

const shopFormRules = {
  adcId: [{ required: true, message: '请填写支付宝门店行政区划！' }],
  address: [{ required: true, message: '请填写支付宝门店地址！' }],
  shopType: [{ required: true, message: '请选择支付宝门店类型！' }],
  shopName: [{ required: true, message: '请填写支付宝门店名称！' }],
}

export default {
  name: 'StoreEditModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    },
    name: {
      type: String,
      default: () => ""
    }
  },
  data () {
    return {
      shopForm,
      shopFormRules,
      adcOptions:[],
      templateList:[],
      industryList:[],
      uploading: false,
      confirmLoading:false,
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          const {shopName,storeId,adcId,shopType,address,contactMobile,contactPhone,ipRoleId,legalName,legalCertNo,shopCategory} = this.obj
          this.shopForm = {shopName,storeId,shopType,address,contactMobile,contactPhone,ipRoleId,legalName,legalCertNo,shopCategory}
          this.shopForm.adcId = [adcId]
          this.shopForm.shopName = this.name
          this.getAdcInfo(this.shopForm.adcId[0])
        })
      }
      if (val && !this.obj){
        this.shopForm.shopName = this.name
        this.getAdcBaseList()
      }
    }
  },

  created() {
    this.handleGetIndustryList()
  },
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.shopForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.shopForm)
          this.confirmLoading = true
        }
      })
    },
    handleGetIndustryList(){
      let _this = this
      QueryIndustrySimplifyList().then(res=>{
        _this.industryList = res.collection
      })
    },
    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.shopForm.resetFields()
      this.shopForm = shopForm
      this.confirmLoading = false
    },
    getAdcInfo(id){
      QueryAdcInfo({id}).then(res=>{
        console.log(res)
        let data = res.data
        this.shopForm.adcId = [data.provinceCode, data.cityCode, data.districtCode]
        this.getAdcBaseList()
      })
    },

    getAdcBaseList(){
      let _this= this
      QueryAdcList({adcType: 2,parentId: ''}).then(res=>{
        let data = res.collection
        data.forEach(item=>{
          let param = {
            value: item.id,
            label: item.provinceName,
            adcType:item.adcType,
            isLeaf: false,
          }
          if (_this.obj && item.id === _this.shopForm.adcId[0]){
            param.children = []
            QueryAdcList({adcType: 3,parentId: item.id}).then(res1=>{
              let data1 = res1.collection
              data1.forEach(item1=>{
                let param1 = {
                  value: item1.id,
                  label: item1.cityName,
                  adcType:item1.adcType,
                  isLeaf: false,
                }
                if (_this.obj && item1.id === _this.shopForm.adcId[1]){
                  param1.children = []
                  QueryAdcList({adcType: 4,parentId: item1.id}).then(res2=>{
                    let data2 = res2.collection
                    data2.forEach(item2=> {
                      let param2 = {
                        value: item2.id,
                        label: item2.districtName,
                        adcType: item2.adcType,
                        isLeaf: true,
                      }
                      param1.children.push(param2)
                    })
                  })
                }
                param.children.push(param1)
              })
            })
          }
          _this.adcOptions.push(param)
        })
      })
    },
    loadAdcData(selectedOptions){
      const targetOption = selectedOptions[selectedOptions.length - 1]
      if (targetOption.adcType < 4) {
        targetOption.loading = true
        let adcType = targetOption.adcType + 1
        QueryAdcList({adcType: adcType ,parentId: targetOption.value}).then(res=>{
          let data = res.collection
          targetOption.children = []
          data.forEach(item=>{
            targetOption.children.push({
              value: item.id,
              label: adcType === 3? item.cityName : (adcType===4 ? item.districtName : item.provinceName),
              adcType:item.adcType,
              isLeaf: adcType===4,
            })
          })
          targetOption.loading = false
          this.adcOptions = [...this.adcOptions]
        })
        targetOption.loading = false
      }
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
